module.exports = __webpack_public_path__ + "static/media/loader_wedlove.bf5a08c9.gif";